// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlidpf{flex-grow:0}\n._18u0idpf{margin-left:0}\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._1bah1h6o{justify-content:center}\n._1bsb7vkz{width:1pc}\n._1e0c1txw{display:flex}\n._1o9zidpf{flex-shrink:0}\n._2hwxutpp{margin-right:var(--ds-space-150,9pt)}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}\n._i0dlexct{flex-basis:16px}\n._otyridpf{margin-bottom:0}\n._syaz1oju{color:var(--ds-icon-subtle,#626f86)}\n._syaz1yjp{color:var(--ds-icon-success,#22a06b)}", ""]);
// Exports
module.exports = exports;
